import { useLayoutEffect, useState } from 'react';

const isBrowser = typeof window !== `undefined`;

const getScrollYPosition = () => {
  if (!isBrowser) {
    return 0;
  }
  return window.scrollY;
};

export const useScrollPosition = (callback: (prevValue: number, value: number) => void) => {
  const [prevScroll, setPrevScroll] = useState(0);
  const [scroll, setScroll] = useState(0);

  useLayoutEffect(() => {
    const handleScroll = () => {
      if (scroll) {
        setPrevScroll(scroll);
      }
      setScroll(getScrollYPosition());
    };
    callback(prevScroll, scroll);

    window.addEventListener(`scroll`, handleScroll);

    return () => window.removeEventListener(`scroll`, handleScroll);
    // eslint-disable-next-line
  }, [scroll]);
};
